import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Anchor, Group, Loader } from 'xen-ui';
/**
 * Useful when you want to render a control that looks like a link (e.g. underlined text) but
 * behaves like a button (e.g. onClick event).
 */
export const LinkButton = ({ disabled = false, loading, ...props }) => {
    return (_jsxs(Group, { component: "span", display: "inline-flex", gap: "xxxs", wrap: "nowrap", children: [_jsx(Anchor, { component: "button", disabled: disabled ?? loading, fz: "inherit", ta: "left", underline: "always", ...props }), loading !== undefined && _jsx(Loader, { color: loading ? undefined : 'transparent', size: "1em" })] }));
};
